import React from 'react';
import { CustomSwitch } from 'components';
import styles from './WebCamSwitch.module.scss';
import cn from 'classnames';

const WebCamSwitch = ({
    value, name, webCam, onClick, containerClassName, darkness,
}: IProps) => (
        <CustomSwitch
          value={value}
          name={name}
          onClick={onClick}
          iconClassName={!webCam
                ? cn(styles.switchIcon_screen, darkness && styles.switchIcon_screen_white)
                : cn(styles.switchIcon_webCam, darkness && styles.switchIcon_webCam_white)}
          pinClassName={cn(styles.switchPin, darkness && styles.switchPin_white)}
          containerClassName={cn(styles.switch, darkness && styles.switch_darkness, containerClassName)}
        />
    );

export default WebCamSwitch;

interface IProps {
    value: boolean;
    name: string;
    webCam?: boolean;
    containerClassName?: string;
    darkness?: boolean;
    onClick: () => void;
}
